<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$root.state.facility" :to="{ name: 'Facility Leasing' }">{{
          String($root.state.facilityData.code).toUpperCase() }}
          Leasing</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-card class="upper" v-if="facilityData && facilityData.bannerNote"
      :body-style="{ padding: '10px 15px', textAlign: 'left' }">
      <i class="el-icon-info" style="padding-right: 10px"></i>
      {{ facilityData.bannerNote }}
    </el-card>
    <div class="leasing-wrapper">
      <el-card class="new-customers" body-style="padding: 0">
        <div slot="header">
          New Customers
        </div>
        <el-table :data="sfCustomers" v-loading="loading" :header-cell-style="{ padding: '5px' }"
          :cell-style="{ padding: '10px' }">
          <el-table-column label="Name" prop="name">
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button :disabled="scope.row.errored && scope.row.sfErroredData" size="small" class="button"
                type="primary" icon="el-icon-plus" @click="convertSFCustomer(scope.row)" round>
              </el-button>
              <el-button size="small" class="button" type="primary" icon="el-icon-delete"
                @click="deleteSFCustomer(scope.row)" round>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="wait-list" body-style="padding: 0">
        <div slot="header">
          <span>
            Wait List
          </span>
          <el-button :disabled="selectedWaitlist.length > 0" size="small" class="button" type="primary"
            icon="el-icon-plus" @click="() => dialogFormVisible = true" round>
            Add
          </el-button>
          <el-button :disabled="selectedWaitlist.length === 0 || deleteButtonLoading" size="small" class="button"
            type="primary" icon="el-icon-delete" @click="deleteWaitList" round>
            Delete
          </el-button>
          <el-button :disabled="selectedWaitlist.length > 1 || selectedWaitlist.length === 0" size="small" class="button"
            type="primary" icon="el-icon-refresh" @click="() => rentalFormVisible = true" round>
            Convert
          </el-button>
        </div>
        <el-table ref="waitListTable" :data="waitList" v-loading="waitListLoading"
          @selection-change="handleSelectionChange" @sort-change="fetchWithSort" :cell-style="{ padding: '0' }"
          :header-cell-style="{ padding: '5px' }">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <!-- <el-table-column>
          <template slot="header">
            <el-select
              class="status"
              size="small"
              placeholder="Sort"
              @change="filterStatus"
            >
              <el-option label="By Size" value="size">
              </el-option>
              <el-option label="By Days" value="days">
              </el-option>
            </el-select>
          </template>
        </el-table-column> -->
          <el-table-column label="In List" width="100" prop="days" sortable="customer">
            <template slot-scope="scope">
              <h4>{{ getDays(scope.row.createdAt) }} Days</h4>
            </template>
          </el-table-column>
          <el-table-column label="Customer" prop="customerId.company">
          </el-table-column>
          <el-table-column label="Min Size" prop="minSize" sortable="custom">
          </el-table-column>
          <el-table-column label="Max Size" prop="maxSize">
            <template slot-scope="scope">
              <span v-if="scope.row.maxSize && scope.row.maxSize > scope.row.minSize">
                {{ scope.row.maxSize }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Size Note" prop="sizeNote">
          </el-table-column>
          <el-table-column label="Note" prop="note">
          </el-table-column>
          <el-table-column label="Desired Date">
            <template slot-scope="scope">
              <span>
                {{ new Date(scope.row.desiredDate).toISOString().slice(0, 10) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="available-units" body-style="padding: 0">
        <div slot="header" class="clearfix">
          <span>Available Units</span>
        </div>
        <el-table :data="units" style="width: 100%" v-loading="loading" empty-text="No Data"
          @sort-change="fetchAvailableUnitsWithSort" :header-cell-style="{ padding: '5px' }">
          <el-table-column width="100" property="name" label="Unit" sortable="name">
            <template slot-scope="scope">
              <el-button type="text" @click="() => routeToUnit(scope.row)">
                {{ scope.row.name }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column width="100" label="Size" prop="computedSize" sortable="computedSize">
          </el-table-column>
          <el-table-column property="type" label="Unit kind" :width="120">
            <template slot="header">
              <el-select class="type" label="Type" v-model="typeSearch" size="small" placeholder="Unit Kind"
                no-match-text="Type not set" no-data-text="Type not set" @change="filterTypes">
                <el-option v-for="item in unitKinds" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </template>

          </el-table-column>
          <el-table-column label="Dimensions" :width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.length }} x {{ scope.row.width }}</span>
            </template>
          </el-table-column>
          <el-table-column property="status" :width="150" label="Status" sortable
            :formatter="(row, column, cellValue) => $options.filters.printableStatus(cellValue)">
          </el-table-column>
          <el-table-column label="Availability" property="availability" :width="150" sortable>
          </el-table-column>
          <el-table-column :width="200" label="Asking Price" sortable prop="askingPrice">
            <template slot-scope="scope">
              {{ scope.row.price | currencySign(scope.row.price, $root.state.facilityData) }}
              <span v-if="scope.row.securityFeeEnabled">
                + {{ scope.row.securityFee | currencySign(scope.row.securityFee, $root.state.facilityData) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column width="300" prop="tags" label="Tags">
            <template slot-scope="scope">
              <el-tag size="mini" :key="tag._id" v-for="tag of scope.row.tags">{{ tag.value }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Actions" :width="100" fixed="right">
              <template slot-scope="scope">
                <el-button @click="() => emailUnitPhotos(scope.row)" icon="el-icon-message" size="small" v-if="scope.row.images && scope.row.images.length > 0" circle>
                </el-button>
                <el-button @click="() => copyText(scope.row)" icon="el-icon-copy-document" size="small" circle></el-button>
              </template>
            </el-table-column>
        </el-table>
        <el-pagination v-show="!loading" hide-on-single-page background :total="totalCount" layout="prev, pager, next"
          @current-change="handlePages">
        </el-pagination>
      </el-card>
    </div>
    <el-dialog id="wait" :visible.sync="dialogFormVisible">
      <customer-wait-list :facility="facility" @close="closeDialog" />
    </el-dialog>
    <el-dialog id="rental" :visible.sync="rentalFormVisible" destroy-on-close>
      <customer-rental v-if="selectedWaitlist.length === 1" :facility="facility"
        :customer-id="selectedWaitlist[0].customerId._id" :wait-list="selectedWaitlist[0]" @close="closeRental"
        @error="closeErrorRental" />
    </el-dialog>
    <el-dialog id="create-customer" :visible.sync="createCustomerFormVisible" destroy-on-close fullscreen
      @close="closeNewCustomer">
      <CreateCustomer v-if="newCustomer.email" :new-customer="newCustomer" @load="closeNewCustomer" />
    </el-dialog>
    <el-dialog :visible.sync="sendEmailDialogVisible" destroy-on-close>
      <h1>Email Photos</h1>
      <el-form :model="emailForm" ref="emailForm" v-loading="loading">
        <el-form-item label="Name"
          prop="name"
          :rules="[
           {
             required: true,
             message: 'Please input name',
             trigger: 'blur',
           },
         ]"
       >
         <el-input v-model="emailForm.name" />
       </el-form-item>
        <el-form-item label="Email"
          prop="email"
          :rules="[
           {
             required: true,
             message: 'Please input email address',
             trigger: 'blur',
           },
           {
             type: 'email',
             message: 'Please input correct email address',
             trigger: ['blur', 'change'],
           },
         ]"
       >
         <el-input v-model="emailForm.email" />
       </el-form-item>
      <el-form-item label="Send Floor Plan">
          <el-checkbox v-model="sendFloorPlan" :disabled="!Boolean(hasFloorPlan)"></el-checkbox>
        </el-form-item>
       <el-form-item>
          <el-button type="primary" :disabled="!emailForm.email" @click="sendEmail">
            Send
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
import axios from 'axios';
import { UNITS_API_BASE_V2, CUSTOMER_API_BASE, ADMIN_API_BASE, EMAIL_API_BASE } from '../env';
import { getFacility } from '../utils/commonApi';
import CustomerWaitList from './CustomerWaitList.vue';
import CreateCustomer from './CreateCustomerV2';
import CustomerRental from './CustomerRental.vue';
import { computeUnitPricing, round } from '../utils/pricing';
import { unitEmailV2Template } from '../utils/emailTemplates';

export default {
  name: 'Units',
  components: { CustomerWaitList, CustomerRental, CreateCustomer },
  props: {
    facility: { type: String, required: true },
  },
  watch: {
    async facility() {
      this.loading = true;
      this.waitListLoading = true;
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
      this.currentPage = 1;
      this.facilityData = await getFacility(this.facility, {
        token: this.$keycloak.token,
        signal: this.abortController.signal,
      });
      await Promise.all([
        this.getUnits(),
        this.getSFCustomers(),
        this.getWaitList(),
      ]);
      this.loading = false;
      this.waitListLoading = false;
    },
  },
  async mounted() {
    this.abortController = new AbortController();
    this.facilityData = await getFacility(this.facility, {
      token: this.$keycloak.token,
      signal: this.abortController.signal,
    });
    await Promise.all([
      this.getUnits(),
      this.getSFCustomers(),
      this.getWaitList(),
    ]);

    this.loading = false;
  },
  computed: {
    hasFloorPlan() {
      const facilityData = this.facilityData;
      const officialDocs = facilityData ? facilityData.officialDocs : [];
      console.log('officialDocs', [...officialDocs].find(doc => doc.name === 'Floor Plan'));
      return [...officialDocs].find(doc => doc.name === 'Floor Plan');
    },
  },
  data() {
    return {
      unit: null,
      sendEmailDialogVisible: false,
      emailForm: {
        email: '',
        name: '',
      },
      sendFloorPlan: false,
      abortController: null,
      deleteButtonLoading: false,
      selectedWaitlist: [],
      units: [],
      sfCustomers: [],
      customers: [],
      waitList: [],
      newCustomer: {},
      loading: true,
      waitListLoading: true,
      typeSearch: 'Warehouse',
      unitKinds: ['All', 'Warehouse', 'Office', 'Parking'],
      search: '',
      dialogFormVisible: false,
      rentalFormVisible: false,
      createCustomerFormVisible: false,
      sortBy: 'computedSize',
      sorting: true,
      sortByDays: true,
      sortBySize: true,
      facilityData: null,
      totalCount: 0,
      page: 0,
      currentPage: 1,
    };
  },
  methods: {
    async deleteSFCustomer(customer) {
      try {
        this.loading = true;
        await axios.delete(`${ADMIN_API_BASE}/customers/salesforce/${customer._id}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        await this.getSFCustomers();
      } catch (err) {
        this.loading = false;
      }
    },
    async convertSFCustomer(customer) {
      if (!customer) { return; }

      this.newCustomer = {
        email: customer.contactEmail,
        company: customer.name,
        salesforceId: customer.sfId,
        business: customer.business,
        subIndustry: customer.space,
      };

      this.createCustomerFormVisible = true;
    },
    async copyText(unit) {
      try {
        const availability = unit.availability ? unit.availability.split('/') : '';
        const tagsExist = unit.tags.filter(item => item.value !== 'No Photos').length > 0;
        const tagsText = tagsExist ? unit.tags.filter(item => item.value !== 'No Photos').map(tag => tag.value).join(', ') : '';
        const availabilityText = availability.length > 1 ? ` (Available ${availability[0]}/${availability[1]})` : '';
        const availabilityAndTags = `${availabilityText}${tagsText ? ' | ' : ''}${tagsText}`;
        const label = unit.securityFeeEnabled && this.facilityData.securityFee ? this.facilityData.securityFee.label : 'Security Fee';
        const securityFeeText = unit.securityFeeEnabled ? ` + $${unit.securityFee.toLocaleString('en-US')}/mo ${label}` : '';
        const price = Math.round(unit.price).toLocaleString('en-US');
        const unitType = unit.type === 'Office' ? 'Office' : 'Unit';
        const text = `${unitType} ${unit.name} - ${unit.computedSize} SF - $${price}/mo${securityFeeText}${availabilityAndTags}`;
        await navigator.clipboard.writeText(text);
        this.$message.success({
          title: 'Copied',
          message: 'Unit info copied to clipboard',
        });
      } catch (err) {
        this.$message.error({
          title: 'Error',
          message: err.message,
        });
      }
    },
    async handlePages(newPage) {
      this.currentPage = newPage;
      this.loading = true;
      await this.getUnits();
      this.loading = false;
    },
    computedPrice(payload) {
      const { unit } = payload;
      const sfPrice = computeUnitPricing(unit, this.facilityData);

      return round(sfPrice);
    },
    async fetchWithSort({ column, prop, order }) {
      if (prop === 'days' && order === 'descending') {
        this.sortByDays = true;
        this.sortBySize = false;
      } else if (prop === 'minSize' && order === 'descending') {
        this.sortBySize = true;
        this.sortByDays = false;
      } else {
        this.sortBySize = false;
        this.sortByDays = false;
      }

      await this.getWaitList();
    },
    async fetchAvailableUnitsWithSort({ column, prop, order }) {
      if (prop) {
        this.sortBy = prop;
        this.sorting = order === 'descending';
      }
      await this.getUnits();
    },
    async closeNewCustomer() {
      this.newCustomerFormVisible = false;
      await this.getSFCustomers();
      this.newCustomer = {};
    },
    async closeRental() {
      this.rentalFormVisible = false;
      await this.deleteWaitList();
      this.selectedWaitlist = [];
    },
    async closeErrorRental() {
      this.rentalFormVisible = false;
      this.selectedWaitlist = [];
    },
    async getSFCustomers() {
      try {
        this.loading = true;
        this.sfCustomers = [];
        const response = await axios.get(`${ADMIN_API_BASE}/customers/salesforce/facility/${this.facilityData._id}`, {
          signal: this.abortController.signal,
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.loading = false;
        // eslint-disable-next-line no-console
        this.sfCustomers = response.data;
      } catch (err) {
        this.loading = false;
      }
    },
    async getWaitList() {
      this.waitListLoading = true;
      const response = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/customer/facility/wait/list/${this.facility}`, {
        signal: this.abortController.signal,
        params: {
          ...(this.sortByDays ? { days: true } : {}),
          ...(this.sortBySize ? { size: true } : {}),
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.waitList = response.data;
      this.waitListLoading = false;
    },
    async closeDialog() {
      this.dialogFormVisible = false;
      this.loading = true;
      await this.getWaitList();
      await this.getUnits();
      this.loading = false;
    },
    async sendEmail() {
      this.loading = true;
      const facilityData = this.facilityData;
      try {
        const tags = this.unit.tags.map(item => item.value).filter(tag => tag !== 'No Photos');
        if (this.unit.images.length > 0) {
          const mjmlTemplate = unitEmailV2Template(
            this.emailForm.name,
            facilityData.title,
            facilityData.addressInfo,
            this.unit,
            { ...this.facilityData.manager, ...this.$keycloak.tokenParsed },
            tags,
            this.unit.price,
            facilityData.pricing.currency,
            this.facilitySecurityFee,
            this.facilityData.rentTaxFlag,
            this.facilityData.tax ? this.facilityData.tax.rentTaxLabel : null,
          );
          await axios.post(`${EMAIL_API_BASE}/send/email`, {
            from: this.$keycloak.tokenParsed.email,
            to: this.emailForm.email,
            cc: this.$keycloak.tokenParsed.email,
            subject: 'Requested ReadySpaces Unit Photos',
            facility: facilityData._id,
            mjml: true,
            body: mjmlTemplate,
            attachments: [...(this.hasFloorPlan && this.sendFloorPlan ? [{
              name: 'FloorPlan.pdf',
              type: 'application/pdf',
              url: this.hasFloorPlan.url,
            }] : [])],
          }, {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });

          this.emailForm.email = '';
          this.emailForm.name = '';
          this.$message.success({
            title: 'Email sent',
            message: 'Email sent successfully',
          });
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.warning({
            title: 'Images Does not exist',
            message: 'This unit does not have any images',
          });
        }
      } catch (err) {
        this.loading = false;
        this.$message.error({
          title: 'Error',
          message: 'Send email failed',
        });
      }
    },
    emailUnitPhotos(unit) {
      this.sendEmailDialogVisible = true;
      this.unit = unit;
    },
    async getUnits() {
      try {
        this.loading = true;
        const units = await axios.get(`${UNITS_API_BASE_V2}/availability/${this.facility}`, {
          signal: this.abortController.signal,
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
          params: {
            ...(this.currentPage ? { pageNumber: this.currentPage } : {}),
            ...(this.sortBy ? { sortBy: this.sortBy } : {}),
            ...(this.sorting ? { sorting: this.sorting } : {}),
            ...(!this.typeSearch || this.typeSearch === 'All' ? {} : { type: this.typeSearch }),
          },
        });

        // eslint-disable-next-line no-restricted-syntax
        for (const unit of units.data.data) {
          // eslint-disable-next-line no-await-in-loop
          const qualityPricing = unit.type === 'Warehouse' ? unit.facility.pricing.qualityPricing
            : unit.type === 'Office' ? unit.facility.officePricing.qualityPricing :
              unit.facility.parkingPricing.qualityPricing;

          const dTier = unit.type === 'Warehouse' ? unit.facility.pricing.dTier
            : unit.type === 'Office' ? unit.facility.officePricing.dTier :
              [];

          unit.price = this.computedPrice({
            unit,
            qualityPricing,
            dTier,
            start: new Date(),
          });

          unit.securityFeeEnabled = unit.facility.securityFee && unit.facility.securityFee.enabled && unit.facility.securityFee.fee > 0;
          unit.securityFee = this.computeSecurityFee(unit);

          unit.askingPrice = unit.price + unit.securityFee;
        }
        this.units = units.data.data.map((unit) => {
          let availability = '-';
          if (unit.availability && unit.availability !== '1/1/1970') availability = unit.availability;
          else if (unit.status === 'OVERDUE_AMOUNT') availability = 'Unknown';
          return {
            ...unit,
            availability,
          };
        });
        this.totalCount = units.data.pagination.totalCount;
        this.pages = this.totalCount / 10;
        this.currentPage = units.data.pagination.pageNo;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: err.message ? err.message : err.response.data,
        });
      }
    },
    computeSecurityFee(row) {
      let fee = 0;

      if (row.securityFeeEnabled) {
        fee = round((row.facility.securityFee.fee / 100) * row.computedSize);
      }
      return fee;
    },
    handleSelectionChange(val) {
      this.selectedWaitlist = val;
    },
    async deleteWaitList() {
      this.deleteButtonLoading = true;
      for (const waitList of this.selectedWaitlist) {
        const response = await axios.delete(`${CUSTOMER_API_BASE}/customers/v1/customer/wait/list/item/${waitList._id}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
      }
      this.deleteButtonLoading = false;
      await this.getWaitList();
    },
    async filterTypes() {
      this.loading = true;
      await this.getUnits();
      this.loading = false;
    },
    getDays(date) {
      const oneDay = 24 * 60 * 60 * 1000;
      const firstDate = new Date(date);
      const secondDate = new Date();
      return Math.round(Math.abs((firstDate - secondDate) / oneDay));
    },
    routeToHomePage() {
      this.$router.push('/');
    },
    routeToCustomer(row) {
      // eslint-disable-next-line no-underscore-dangle
      this.$router.push({ name: 'Facility Customer', params: { id: row._id, facility: this.facility } });
    },
    routeToUnit(row) {
      // eslint-disable-next-line no-underscore-dangle
      this.$router.push({ name: 'Facility Unit', params: { unit: row._id, facility: this.facility } });
    },
  },
};
</script>

<style scoped>
.upper {
  margin-bottom: 1rem;
}

.button {
  margin: 0 5px;
  float: right;
}

.leasing-wrapper {
  display: grid;
  gap: 1rem;
}

@media (min-width: 768px) {
  .leasing-wrapper {
    grid: 1fr / repeat(6, 1fr);
  }

  .new-customers {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
  }

  .wait-list {
    grid-column: 3 / 7;
    grid-row: 1 / 2;
  }

  .available-units {
    grid-row: 2;
    grid-column: 1 / 7;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Leasing.vue